module.exports = "/images/vendor/flag-icon-css/flags/4x3/no.svg?0b41df77e951a30bbfccfd0a3714a1a3";